(() => {
  const button = document.querySelector('[data-cos-radio]');
  if (!button || window.cosRadioReady) return;
  window.cosRadioReady = true;
  let context, master, timer, step = 0, next = 0, noiseBuffer;
  let enabled = true, started = false;
  try { enabled = localStorage.getItem('cos-radio') !== 'off'; } catch {}
  const text = button.querySelector('[data-radio-label]');
  const paint = () => {
    button.setAttribute('aria-pressed', String(enabled && started && context?.state === 'running'));
    button.setAttribute('aria-label', enabled && started ? button.dataset.mute : button.dataset.play);
    text.textContent = enabled && started ? button.dataset.on : button.dataset.off;
  };
  const note = (frequency, time, duration, volume, type = 'sine', cutoff = 900) => {
    const oscillator = context.createOscillator(), gain = context.createGain(), filter = context.createBiquadFilter();
    oscillator.type = type; oscillator.frequency.setValueAtTime(frequency, time);
    filter.type = 'lowpass'; filter.frequency.value = cutoff;
    gain.gain.setValueAtTime(0, time); gain.gain.linearRampToValueAtTime(volume, time + .012);
    gain.gain.exponentialRampToValueAtTime(.0001, time + duration);
    oscillator.connect(filter).connect(gain).connect(master);
    oscillator.start(time); oscillator.stop(time + duration + .03);
  };
  const noise = (time, duration, volume, cutoff) => {
    const source = context.createBufferSource(), filter = context.createBiquadFilter(), gain = context.createGain();
    source.buffer = noiseBuffer; filter.type = 'highpass'; filter.frequency.value = cutoff;
    gain.gain.setValueAtTime(volume, time); gain.gain.exponentialRampToValueAtTime(.0001, time + duration);
    source.connect(filter).connect(gain).connect(master); source.start(time); source.stop(time + duration);
  };
  const kick = time => {
    const oscillator = context.createOscillator(), gain = context.createGain();
    oscillator.frequency.setValueAtTime(130, time); oscillator.frequency.exponentialRampToValueAtTime(43, time + .12);
    gain.gain.setValueAtTime(.6, time); gain.gain.exponentialRampToValueAtTime(.0001, time + .24);
    oscillator.connect(gain).connect(master); oscillator.start(time); oscillator.stop(time + .25);
  };
  const schedule = () => {
    if (!enabled || document.hidden || context.state !== 'running') return;
    if (next < context.currentTime) next = context.currentTime + .03;
    while (next < context.currentTime + .12) {
      const beat = step % 16, bar = Math.floor(step / 16) % 16;
      const roots = [41.203, 41.203, 36.708, 43.654], root = roots[Math.floor(bar / 4)];
      if ([0,6,10].includes(beat) || (bar % 2 && beat === 14)) kick(next);
      if (beat === 4 || beat === 12) { noise(next, .15, .24, 1100); note(170, next, .1, .12, 'triangle'); }
      if (beat % 2 === 0) noise(next, .032, beat % 4 === 0 ? .07 : .045, 7000);
      if (beat === 15 && bar % 2) noise(next, .05, .035, 6500);
      if ([0,3,6,8,11,14].includes(beat)) note(root * (beat === 11 ? 2 : 1), next, .19, .3, 'sawtooth', 260 + beat * 18);
      if (beat === 0 && bar % 2 === 0) {
        [4, 4 * 1.189207, 6].forEach(f => note(root * f, next, 2.3, .055, 'triangle', 1300));
      }
      if (bar >= 4 && [2,7,10,15].includes(beat)) {
        const melody = [8, 6, 4.7568, 6, 8, 9.5136, 6, 4];
        note(root * melody[(bar + Math.floor(beat / 4)) % melody.length], next, .3, .065, 'triangle', 2100);
      }
      step++; next += 60 / 108 / 4;
    }
  };
  const start = async () => {
    if (!enabled || document.hidden) return;
    try {
      if (!context) {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) { button.hidden = true; return; }
        context = new AudioContext(); master = context.createGain(); master.gain.value = .09;
        const compressor = context.createDynamicsCompressor(); master.connect(compressor).connect(context.destination);
        noiseBuffer = context.createBuffer(1, context.sampleRate, context.sampleRate);
        const data = noiseBuffer.getChannelData(0); let seed = 3502;
        for (let i = 0; i < data.length; i++) { seed = (seed * 16807) % 2147483647; data[i] = (seed / 2147483647) * 2 - 1; }
      }
      await context.resume();
      if (context.state !== 'running') return;
      started = true; next = context.currentTime + .05;
      if (!timer) timer = setInterval(schedule, 25);
      paint();
    } catch { paint(); }
  };
  const pause = () => { if (timer) { clearInterval(timer); timer = undefined; } context?.suspend().catch(() => {}); };
  button.addEventListener('click', async event => {
    event.stopPropagation();
    if (!started || !enabled) { enabled = true; await start(); } else { enabled = false; pause(); }
    try { localStorage.setItem('cos-radio', enabled ? 'on' : 'off'); } catch {}
    paint();
  });
  const unlock = event => { if (!event.target.closest('[data-cos-radio],input,textarea,select') && enabled && !started) start(); };
  document.addEventListener('pointerdown', unlock);
  document.addEventListener('keydown', unlock);
  document.addEventListener('visibilitychange', () => { if (document.hidden) pause(); else if (started && enabled) start(); });
  window.addEventListener('pagehide', pause);
  window.addEventListener('pageshow', () => { if (started && enabled) start(); });
  paint();
})();
